import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', type = 'text', ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={[
        'flex w-full rounded-md border border-border bg-white px-3 py-2',
        'text-sm text-text-primary placeholder:text-text-secondary',
        'focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'transition-colors',
        className,
      ].join(' ')}
      {...props}
    />
  )
);

Input.displayName = 'Input';
